import { sanitizeSameOriginPath } from "@sg-protect/core";

const RETURN_TO_PARAM = "returnTo";

/**
 * Resolves the wizard's exit target from `?returnTo=`, rejecting anything that isn't an
 * in-app relative path (e.g. an absolute/protocol-relative URL) to avoid navigating somewhere
 * unexpected.
 */
export function resolveReviewWizardExitTarget(searchParams: URLSearchParams, reviewsPath: string): string {
    return sanitizeSameOriginPath(searchParams.get(RETURN_TO_PARAM)) ?? `${reviewsPath}?tab=draft`;
}

/**
 * Builds the query string used to enter the review wizard with a `returnTo` target to exit back to.
 */
export function buildReviewWizardEntryQuery(returnTo: string): string {
    return new URLSearchParams({ [RETURN_TO_PARAM]: returnTo }).toString();
}
